import { DEFAULT_LOCALE, Locale, PseudoLocale } from "../../../types/Locale"

export function getContentfulLocale(locale: string): string {
  if (PseudoLocale.isPseudoLocale(locale)) {
    return DEFAULT_LOCALE.toString()
  }
  return Locale.getLocaleFromString(locale)?.contentfulLanguageTag ?? locale
}
